import Vue from 'vue'
import { MutationTree, ActionTree } from 'vuex'
import { MUTATIONS_TOASTS, ACTIONS_TOASTS } from '@/enums'
import { Toast, IToastConfig, IStateToasts, IStateRoot } from '@/models'

const state: IStateToasts = {
    toasts: [],
}

const mutations: MutationTree<IStateToasts> = {
    [MUTATIONS_TOASTS.ADD_TOAST](state, toast: Toast) {
        state.toasts.push(toast)
    },

    [MUTATIONS_TOASTS.REMOVE_TOAST](state, uuid) {
        const toastIndex = state.toasts.findIndex((toast: Toast) => toast.uuid === uuid)

        if (toastIndex !== -1) Vue.delete(state.toasts, toastIndex)
    },
}

const actions: ActionTree<IStateToasts, IStateRoot> = {
    [ACTIONS_TOASTS.CREATE_TOAST]({ commit }, toastData: IToastConfig): string {
        const toast = new Toast(toastData)

        commit(MUTATIONS_TOASTS.ADD_TOAST, toast)

        return toast.uuid
    },
}

export const storeModuleToasts = {
    namespaced: true,
    state,
    mutations,
    actions,
}
